<!-- Footer Section Starts -->
<!-- <footer class="footer-sec py-8 md:py-5 lg:px-5 text-white">
  <div class="container mx-auto flex flex-col lg:flex-row items-center justify-between">
    <div class="lg:w-1/2 flex items-center justify-center lg:justify-start mb-4 lg:mb-0">
      <div class="flex flex-wrap items-center lg:flex-nowrap text-xs justify-center" id="footer">
        <div class="flex-none m-1">
          <a routerLink="/privacy-policy" target="_blank" routerLinkActive="disabled">Privacy Policy</a> |
        </div>
        <div class="flex-initial m-1">
          <a routerLink="/refund-policy" target="_blank" routerLinkActive="disabled">Refund Policy</a> |
        </div>
        <div class="flex-initial m-1">
          <a routerLink="/terms-conditions" target="_blank" routerLinkActive="disabled">Terms & Conditions</a>
        </div>
      </div>
    </div>
    <div class="lg:w-1/2 flex justify-center lg:justify-end">
      Copyright Section Starts
      <div class="text-xs text-white text-center">
        Copyright © {{date| date:'yyyy'}}, Powered by Medease Booking System
      </div>
    </div>
  </div>
</footer> -->
<!-- Footer Section Ends -->


<footer class="bg-[#112c76f2] p-[1em] xxl:p-0 pt-[80px]">
    <div class="container mx-auto footer-top p-3">
        <div
            class="flex items-center flex-wrap justify-between mb-5 mt-10 mb-5 py-[20px] px-[50px] bg-white shadow-xl rounded-[15px]">
            <div class="flex items-start space-x-4 mb-5 py-[10px]">
                <div
                    class="text-xl text-gray-600 border border-[#ebf2f3] w-[50px] h-[50px] rounded-full mr-[20px] flex items-center justify-center">
                    <span class="material-symbols-outlined footer-style text-[#112c76] font-bold">
                        pin_drop
                    </span>
                </div>
                <div>
                    <p class="">Our Address</p>
                    <p class="text-secondary font-bold text-[#112c76]">4th Floor,CDAC Building, <br/>Technopark Campus,<br/>Trivandrum, Kerala</p>
                </div>
            </div>
            <div class="flex items-start space-x-4 mb-5 py-[10px] pl-0 md:pl-[70px] sm:border-l-2 border-[#ebf2f3]">
                <div
                    class="text-xl text-gray-600 border border-[#ebf2f3] w-[50px] h-[50px] rounded-full mr-[20px] flex items-center justify-center">
                    <span class="material-symbols-outlined footer-style text-[#112c76] font-bold">
                        phone_in_talk
                    </span>
                </div>
                <div>
                    <p class="">Call Us</p>
                   <a href="tel:+919446062493"> <p class="text-secondary font-bold text-[#112c76]">+91 9446062493</p> </a>
                </div>
            </div>
            <div class="flex items-start space-x-4 mb-5 py-[10px] pl-0 lg:pl-[70px] lg:border-l-2 border-[#ebf2f3]">
                <div
                    class="text-xl text-gray-600 border border-[#ebf2f3] w-[50px] h-[50px] rounded-full mr-[20px] flex items-center justify-center">
                    <span class="material-symbols-outlined footer-style text-[#112c76] font-bold">
                        mail
                    </span>
                </div>
                <div>
                    <p class="">Our Mail</p>
                    <a target="_blank" href="mailto:sales@onetikk.com"><p class="text-secondary font-bold text-[#112c76]">{{ 'sales@onetikk.com' }}</p> </a>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-middle p-3 lg:p-0">
        <div class="container mx-auto">
            <div class="grid grid-cols-12 gap-8">
                <div
                    class="col-span-12 sm:col-span-6 lg:col-span-4 xl:col-span-3 pt-[10px] lg:pt-[50px] pb-0 lg:pb-[50px]">
                    <div class="mb-4 footer-logo">
                        <a class="text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap uppercase text-white"
                        href="#">
                        <img src="/assets/images/medease-logo-white.png" alt="logo" class="doctor-logo w-[180px]">
                        </a>
                    </div>
                    <p class="text-white">
                        Empowering your health journey, one appointment at a time.
                    </p>
                    <ul class="flex mt-4 items-center pl-0">
                        <li class="list-none"><a target="_blank" href="https://www.facebook.com/onetikk/"
                                class="text-[#fff] border border-[#ffffff30] w-[50px] h-[50px] rounded-full flex items-center justify-center hover:text-[#dbd1d1]"><i
                                    class="fab fa-facebook-f"></i></a></li>
                        <li class="ml-[10px] list-none"><a target="_blank" href="https://x.com/onetikk?lang=en"
                                class="text-[#fff] border border-[#ffffff30] w-[50px] h-[50px] rounded-full flex items-center justify-center hover:text-[#dbd1d1]"><i
                                    class="fab fa-twitter"></i></a>
                        </li>
                        <li class="list-none ml-[10px]"><a target="_blank" href="https://www.instagram.com/accounts/login/"
                                class="text-[#fff] border border-[#ffffff30] w-[50px] h-[50px] rounded-full flex items-center justify-center hover:text-[#dbd1d1]"><i
                                    class="fab fa-instagram"></i></a></li>
                        <li class="ml-[10px] list-none"><a target="_blank" href="https://www.linkedin.com/company/onetikk/"
                                class="text-[#fff] border border-[#ffffff30] w-[50px] h-[50px] rounded-full flex items-center justify-center hover:text-[#dbd1d1]"><i
                                    class="fab fa-linkedin"></i></a></li>
                      
                    </ul>
                </div>

                <div class="col-span-12 sm:col-span-6 lg:col-span-4 xl:col-span-3 pb-0  sm:pb-[50px] pt-0 lg:pt-[50px]">
                    <h5 class="text-white text-[18px] font-semibold mt-0 mb-4">Specialities</h5>
                    <ul class="space-y-2 pl-0">
                        <li class="list-none text-[14px] font-medium" *ngFor="let specialty of completeSpecialties;" >
                            <button class="text-[#686a6f] bg-transparent text-white ease-in duration-300 cursor-pointer text-[14px] hover:opacity-70" (click)="gotoSpecialityDoctorsList(specialty)">{{specialty.title}}</button>
                        </li>
                        <!-- <li class="list-none"><a href="#" class="text-[#686a6f] hover:text-blue-600">Terms of Use</a>
                        </li>
                        <li class="list-none"><a href="#" class="text-[#686a6f] hover:text-blue-600">Our Services</a>
                        </li>
                        <li class="list-none"><a href="#" class="text-[#686a6f] hover:text-blue-600">New Guests
                                Lists</a></li>
                        <li class="list-none"><a href="#" class="text-[#686a6f] hover:text-blue-600">The Team List</a>
                        </li> -->
                    </ul>
                </div>

                <div class="col-span-12 sm:col-span-6 lg:col-span-4 xl:col-span-3 py-0 sm:py-[50px]">
                    <h5 class="text-white text-[18px] font-semibold mt-0 mb-4">Useful Links</h5>
                    <ul class="space-y-2 pl-0">
                        <li class="list-none"><a href="#" class="text-[14px] text-white opacity-90 hover:opacity-70 ease-in duration-300">Home</a></li>
                        <li class="list-none"><a href="/about" class="text-[14px] text-white opacity-90 hover:opacity-70 ease-in duration-300">About Us</a>
                        </li>
                        <li class="list-none"><a href="/specialities" class="text-[14px] text-white  opacity-90 hover:opacity-70 ease-in duration-300">Specialities</a>
                        </li>
                        <li class="list-none"><a href="/faq" class="text-[14px] text-white opacity-90 hover:opacity-70 ease-in duration-300">FAQ
                                Lists</a></li>
                        <li class="list-none"><a href="/contact" class="text-[14px] text-white opacity-90 hover:opacity-70 ease-in duration-300">Contact Us</a>
                        </li>
                    </ul>
                </div>

                <div class="col-span-12 sm:col-span-6 lg:col-span-4 xl:col-span-3 py-0 lg:py-[50px]">
                    <h5 class="text-white text-[18px] font-semibold mt-0 mb-4">Subscribe</h5>
                    <form method="post" class="space-y-3">
                        <input type="email" name="email" placeholder="&nbsp;&nbsp;Email"
                            class="w-full p-2 border border-gray-300 rounded footer-box">
                        <button type="button"
                            class="w-full bg-[#45a6d1]  hover:bg-[#112c76] ease-in duration-300 cursor-pointer text-white py-2 rounded footer-box">Subscribe</button>
                        <p class="text-sm text-white">Get the latest updates via email. Anytime you may unsubscribe.
                        </p>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <div class="mt-0 lg:mt-[50px] py-[30px]">
        <div class="container mx-auto px-4 flex flex-wrap justify-center  lg:justify-between items-center">
            <div class="text-black footer-font">
                <p class="text-white">Copyright © {{date| date:'yyyy'}}, Powered by Medease Booking System</p>
            </div>
            <!-- <ul class="flex space-x-4 text-gray-600 justify-content-start footer-font pl-0"> -->
                <!-- <li class="list-none"><a href="/privacy-policy" class="text-white hover:text-[#dbd1d1]">Privacy-Policy</a></li>
                <li class="list-none"><a href="" class="text-white">|</a></li>
                <li class="list-none"><a href="/terms-conditions" class="text-white hover:text-[#dbd1d1]">Terms & Conditions</a></li> -->
                <!-- <li class="list-none"><a href="#" class="text-white hover:text-[#112c76]">&nbsp;|&nbsp;Sitemap</a></li>
                <li class="list-none"><a href="#" class="text-white hover:text-[#112c76]">&nbsp;|&nbsp;Help</a></li> -->
            <!-- </ul> -->
            <ul class="nav-list">
                <li class="nav-item">
                    <a href="/privacy-policy" class="nav-link">Privacy Policy</a>
                </li>
                <li class="nav-item">
                    <a href="/terms-conditions" class="nav-link">Terms & Conditions</a>
                </li>
            </ul>            
        </div>
    </div>
</footer>